import { Badge, Highlight } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { StackOrModal } from "../../../../../mantine/components/StackOrModal/StackOrModal";
import type { PPAContract } from "../../PPAContractPage.types";

export function getConsumptionSitesColumn(
  contracts: Array<PPAContract>
): MRT_ColumnDef<PPAContract> {
  const usedConsumptionSites = contracts
    .map((contract) => contract.consumption_sites)
    .flat();
  const usedConsumptionSitesSet = Array.from<string>(
    new Set(usedConsumptionSites)
  );
  const uniqueUsedConsumptionSites = Array.from(usedConsumptionSitesSet).sort();

  return {
    accessorKey: "consumption_sites",
    header: "Entnahmestelle",
    enableSorting: false,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedConsumptionSites
    },
    filterFn: "arrIncludesSome",
    Cell: ({ table, row }) => {
      const search = table.getState().globalFilter ?? "";

      return (
        <StackOrModal
          elementText="Entnahmestellen"
          numElements={row.original.consumption_sites.length}
        >
          {row.original.consumption_sites.map((site) => (
            <Badge color="gray" key={site} variant="outline">
              <Highlight highlight={search}>{site}</Highlight>
            </Badge>
          ))}
        </StackOrModal>
      );
    }
  };
}
